/* eslint-disable */
import { useEffect, useState } from "react"
import { Moon, Sun } from "lucide-react"

const DarkModeToggle = () => {
    useEffect(() => {
        document.documentElement.classList.add('dark'); // pour tester
    }, []);
    const [isDark, setIsDark] = useState(() => {
        const stored = localStorage.getItem("theme")
        if (stored) return stored === "dark"
        return window.matchMedia("(prefers-color-scheme: dark)").matches
    })

    useEffect(() => {
        const root = document.documentElement
        if (isDark) {
            root.classList.add("dark")
            localStorage.setItem("theme", "dark")
        } else {
            root.classList.remove("dark")
            localStorage.setItem("theme", "light")
        }
    }, [isDark])

    return (
        <button
            onClick={() => setIsDark(!isDark)}
            className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-50 dark:bg-[#2a1a38] text-[#9e68ba] hover:bg-purple-100 transition-colors"
        >
            {isDark ? (
                <Sun size={20} className="text-[#9e68ba] dark:text-[#edd9f7]" />
            ) : (
                <Moon size={20} className="text-[#9e68ba] dark:text-[#edd9f7]" />
            )}
        </button>
    )
}

export default DarkModeToggle

